import React, { FC, ReactNode, ReactChild, useContext } from "react";
import { PluginRegistryContext } from "./PluginRegistryContextProvider";
import { PluginStateDefinition } from "./PluginRegistryTypes";

export interface PluginStateProviderProps {
  children: ReactChild | ReactChild[] | undefined | null;
}

export interface PluginStateContext<T> {
  state: T;
  dispatch: React.Dispatch<any> | undefined;
}

export const PluginStateProvider = (props: PluginStateProviderProps) => {
  const { pluginRegistry } = useContext(PluginRegistryContext);
  const pluginStates = pluginRegistry.getAllStateDefinitions();
  let wrappedComponents = <>{props.children}</>;
  pluginStates.forEach(pluginStateDef => {
    wrappedComponents = (
      <StateContextProvider pluginDef={pluginStateDef}>{wrappedComponents}</StateContextProvider>
    );
  });

  return wrappedComponents;
};

export const StateContextProvider = (props: {
  pluginDef: PluginStateDefinition;
  children: ReactChild | ReactChild[] | undefined | null;
}) => {
  const { pluginDef, children } = props;
  return <pluginDef.contextProvider>{children}</pluginDef.contextProvider>;
};
